import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { Field } from 'redux-form';

const LOCALE_PREFIX = 'GB/components/FinancialInfo/FinancialInfo';

export class MonthlyHousing extends Component {
    static propTypes = {
        currencySymbol: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        monthlyHousingListOptions: PropTypes.object.isRequired,
        financialInfo: PropTypes.object.isRequired
    };

    render() {
        const { currencySymbol, intl, monthlyHousingListOptions, financialInfo } = this.props;

        _.forEach(monthlyHousingListOptions, (value, key) => {
            monthlyHousingListOptions[key] = value.replace(/{currencySymbol}/g, currencySymbol);
        });

        return (
            <Field
                id="monthlyHousingPayment"
                name="monthlyHousingPayment"
                component={SelectField}
                optionList={mapOptionsToSelectField(monthlyHousingListOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.monthlyHousingPayment`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.monthlyHousingPayment`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.monthlyHousingPayment-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    currencySymbol: _.get(state, 'serverData.currencySymbol'),
    monthlyHousingListOptions: _.get(state, `serverData.messages[${LOCALE_PREFIX}].applyForBmlUK.monthlyHousingPaymentRange`),
    financialInfo: _.get(state, 'form.ppcreditapply.values.financial-info')
});

export default connect(mapStateToProps)(injectIntl(MonthlyHousing));
